module.exports = __webpack_public_path__ + "media/img/illustrations/designer-life-92ca0207690e3041c3d15e67ae26f18c.svg";